import { GalleryLayout } from '../../types';
export var LayoutRadioValues;
(function(LayoutRadioValues) {
    LayoutRadioValues["GRID"] = "grid";
    LayoutRadioValues["MASONRY"] = "masonry";
})(LayoutRadioValues || (LayoutRadioValues = {}));
export const LayoutRadioValueMapping = {
    ["grid"]: GalleryLayout.GRID,
    ["masonry"]: GalleryLayout.MASONRY
};
